import React, { FC, useEffect, useState } from "react";
import { t } from "@helpers/translate";
import { getDurationFromHourMin } from "@helpers/getDuration";
import { convertTimeTo12HourFormat } from "@helpers/getTimeFormat";
import { InputModal } from "@components/ui/Form";

interface InputProps {
  className?: string;
  defaultValue?: string;
  meetingTimeSlots?: string[];
  showErrorView?: boolean;
  title?: string;
  onApply: (value: string) => void;
  showModal?: boolean;
  showAsDuration?: boolean;
  showIn12Hour?: boolean;
  showEmptyValue?: boolean;
}

export const InputStartTime: FC<InputProps> = ({
  className = "",
  defaultValue,
  meetingTimeSlots,
  title,
  showErrorView = false,
  showModal = false,
  showAsDuration = false,
  onApply,
  showIn12Hour = true,
  showEmptyValue = false,
}) => {
  const [value, setValue] = useState(defaultValue);

  useEffect(() => {
    //Expected time format : HH:MM
    //But sometime we are getting : HH:MM:SS
    if (defaultValue) {
      // Convert HH:MM:SS to HH:MM
      if (defaultValue?.length > 5) {
        setValue(defaultValue?.slice(0, -3));
      } else {
        setValue(defaultValue);
      }
    }
  }, [defaultValue]);

  const [isOpen, setIsOpen] = useState(false);

  const getTimeSlots = () => {
    const defaultValue: string[] = showEmptyValue ? [""] : [];

    const slots = meetingTimeSlots || [
      "09:00",
      "09:30",
      "10:00",
      "10:30",
      "11:00",
      "11:30",
      "12:00",
      "12:30",
      "13:00",
      "13:30",
      "14:00",
      "14:30",
      "15:00",
      "15:30",
      "16:00",
      "17:00",
    ];

    return [...defaultValue, ...slots];
  };

  const displayTime = (time?: string) => {
    if (showIn12Hour && time) {
      return convertTimeTo12HourFormat(time);
    }
    return time;
  };

  return (
    <InputModal
      icon="time"
      showErrorView={showErrorView}
      className={className}
      title={title || t({ id: "tour.input.startTime", message: "Start Time" })}
      value={
        showAsDuration
          ? getDurationFromHourMin(value || "")
          : displayTime(value)
      }
      onApply={() => value && onApply(value)}
      setIsGlobalOpen={(open: boolean) => setIsOpen(open)}
      checkIsOpen={() => {
        if (showModal) {
          return true;
        }
        return isOpen;
      }}
      showApply={false}
    >
      <div className="grid grid-cols-1 overflow-y-scroll max-h-48 min-h-fit">
        {getTimeSlots().map((startTime, key) => {
          return (
            <InputModal.Item
              key={`${startTime}-${key}`}
              isActive={startTime === value}
              onClick={() => {
                setValue(startTime);
                onApply(startTime);
                setIsOpen(false);
              }}
            >
              {showAsDuration && getDurationFromHourMin(startTime)}
              {!showAsDuration && displayTime(startTime)}
            </InputModal.Item>
          );
        })}
      </div>
    </InputModal>
  );
};
